import { ActionTree, ActionContext, Action } from 'vuex'

import {
  IJob,
  IJobStore
} from '@/features/job/store'
import {
  FETCH_JOB,
  FETCH_JOB_LIST,
  FETCH_CURRENT_JOB,
  REMOVE_JOB,
  FETCH_JOB_LIST_ACTION,
  FETCH_JOB_BY_ID_ACTION,
  CLEAR_JOB,
  CLEAR_JOB_LIST,
  FILL_SELECTED_JOB,
  CLEAR_SELECTED_JOB
} from '@/system/store/action-types'
import { SET_JOB, SET_JOBS, CLEAR_JOBS, SET_SELECTED_JOB } from '@/system/store/mutation-types'
import JobService from '@/features/job/job.service'
import { JOB_STATUSES } from '@/constants'
import debounce from 'lodash.debounce'

const jobService = new JobService()

const fetchJob: Action<IJobStore, any> = (
  context: ActionContext<IJobStore, any>,
  job: IJob
): void => {
  return context.commit(SET_JOB, job)
}

const clearJob: Action<IJobStore, any> = (
  context: ActionContext<IJobStore, any>
): void => {
  const job = {
    customerId: '',
    jobId: '',
    status: JOB_STATUSES.PENDING,
    authorId: '',
    createdAt: 0,
    meta: {
      sample: [] as any[],
      processingErrors: [] as any[],
      processingErrorsCount: 0,
      csvValidationErrors: {}
    }
  }
  return context.commit(SET_JOB, job)
}

const clearSelectedJob: Action<IJobStore, any> = (
  context: ActionContext<IJobStore, any>
): void => {
  return context.commit(SET_SELECTED_JOB, null)
}

const fetchJobList: Action<any, any> = (
  context: ActionContext<any, any>,
  { ...jobs }: any
): void => {
  return context.commit(SET_JOBS, jobs)
}

const clearJobList: Action<any, any> = (
  context: ActionContext<any, any>
): void => {
  return context.commit(CLEAR_JOBS, [])
}

const fetchCurrentJob: Action<IJobStore, any> = (
  context: ActionContext<IJobStore, any>,
  uuid: string
): void => {
  const job = context.state.list.find(({ jobId }: IJob) => jobId === uuid)

  return context.commit(SET_JOB, job)
}

const removeJob: Action<IJobStore, any> = async (
  context: ActionContext<IJobStore, any>,
  options: { uuid: string, jobList: IJob[] }
): Promise<any> => {
  const { uuid: jobId } = options
  const payload = { jobId }
  const jobs = context?.state?.list?.filter(({ jobId: id }) => id !== jobId)

  return Promise.all([
    context.commit(SET_JOBS, { jobs }),
    jobService.deleteJob({ payload })
  ])
}

const fetchJobListAction: Action<IJobStore, any> = (): void => {
  return jobService.fetchJobList()
}

const fetchJobIdAction: Action<IJobStore, any> = debounce((context: ActionContext<IJobStore, any>, jobId: string) => {
  return jobService.fetchJobById({
    payload: { jobId }
  })
}, 1000)

const fillSelectedJob: Action<any, any> = (
  context: ActionContext<any, any>,
  job: IJob
): void => {
  return context.commit(SET_SELECTED_JOB, job)
}

const actions: ActionTree<IJobStore, any> = {
  [FETCH_JOB]: fetchJob,
  [FETCH_JOB_LIST]: fetchJobList,
  [FETCH_CURRENT_JOB]: fetchCurrentJob,
  [REMOVE_JOB]: removeJob,
  [FETCH_JOB_LIST_ACTION]: fetchJobListAction,
  [FETCH_JOB_BY_ID_ACTION]: fetchJobIdAction,
  [CLEAR_JOB]: clearJob,
  [CLEAR_JOB_LIST]: clearJobList,
  [FILL_SELECTED_JOB]: fillSelectedJob,
  [CLEAR_SELECTED_JOB]: clearSelectedJob
}

export default actions
